/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export class UrlUtil {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		private static getReplacedQueryStringUrl(url:string, key:string, value:string):string {
			const regExp = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
			const separator = url.indexOf('?') !== -1 ? '&' : '?';
			if (url.match(regExp)) {
				return url.replace(regExp, '$1' + key + '=' + value + '$2');
			}
			else {
				return url + separator + key + '=' + value;
			}
		}

		private static replaceQueryString(key:string, value:string):void {
			const url = UrlUtil.getReplacedQueryStringUrl(window.location.href, key, value);
			const state = url.match(/^https?:\/{2,}.*?(\/.*)/)[1];
			window.history.replaceState(null, null, state);
		}

		public static replaceRecordingStatus(value:string):void {
			UrlUtil.replaceQueryString('status', value);
		}

		public static replaceSpeed(value:string):void {
			// speedパラメータの引き継ぎを無効化
			//UrlUtil.replaceQueryString('speed', value);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------
	}
}
